import { wrapStore } from "vuex-composition-helpers";
import store from "@/store"; // local store file

//Wraps the store and creates a composition function
//which can be used from non component pages for accessing the store object.
const wrappedStore = wrapStore(store);
export default wrappedStore;
export const { createNamespacedHelpers: useStoreModule, useActions, useGetters, useMutations, useState } = wrappedStore;
